import { ChertoExperiments } from 'constants/experiments'
import { getExperimentEnabledDecision } from 'lib/optimizely/optimizelyUtils'
import { getChertoExperimentVariation } from './experimentSelectors'

const variationOptions = { overrideTrigger: true }

/** Read the tour flight rollout without triggering experiment activation or excluding UTM traffic. */
export function getTourFlightsEnabled(state: App.State): boolean {
  const variationKey = getChertoExperimentVariation(state, ChertoExperiments.flightsToursUpsell, variationOptions)

  return getExperimentEnabledDecision(variationKey)
}
